<template>
  <div class="gSwiperBox">
    <swiper :options="swiperOption" ref="mySwiper"> 
      <swiper-slide v-for="(item,index) in adList" :key="index">
        <img :src="item.path" @click="linkTo(item)">
      </swiper-slide> 
    </swiper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "gSwiper",
  data() {
    return {
      swiperOption: { 
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      contentList: [
        { id: 1, url: "" },
        { id: 2, url: "" },
        { id: 3, url: "" },
        { id: 4, url: "" }
      ],
      adList: []
    };
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition"
    }),
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  async created() {
    let req = {
      id: this.exhibition.id,
      typeid: 2
    }
    let res = await this.getCommonAd(req);
    if (res && res.length > 0) {
      this.adList = res;
    } 
  }, 
  methods: {
    ...mapActions({
      getCommonAd: "hostCommonModule/getCommonAd"
    }),
    linkTo(item) {
      if (item.link) {
        window.open(item.link);
      }
    }
  }
};
</script>

<style lang="scss">
.swiper-slide {
  img {
    width: 100%;
    max-height: 192px;
  }
} 
.gSwiperBox .swiper-container {
  font-size: 0; 
}
.gSwiperBox .swiper-pagination {
  font-size: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 18px;
  bottom: 22px;
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    border-radius: 0;
    background-color: #dddddd;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background-color: #ed6e02;
    opacity: 1;
  }
}
</style>